import React from "react";
import axios from "axios";
import Spinner from "components/Spinner";

export default class ContactScreen extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      contactPerson: null,
      contactEmail: null,
      planAdmins: [],
      company: null,
      empId: null,
      error: null,
    };
  }

  componentDidMount() {
    this.startLoading();
  }

  async startLoading() {
    try {
      const params = new URLSearchParams(window.location.search);
      const employeeId = params.get("employeeId");

      if (!employeeId) {
        this.setState({ error: "Employee ID is missing in the URL." });
        return;
      }

      this.setState({ empId: employeeId });

      const response = await axios.get(
        `/api/OpsEmployee/getplanadmins?employeeId=${employeeId}`
      );

      this.setState({
        loaded: true,
        planAdmins: response.data.planAdmins || [],
      });
    } catch (error) {
      console.error("Error fetching plan admins:", error);
      this.setState({ loaded: true, error: "Failed to load plan administrators." });
    }
  }

  renderContent() {
    const { loaded, planAdmins, company, error } = this.state;

    if (!loaded) {
      return <Spinner />;
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    return (
      <div className="br-mainpanel black site-content">
        <div className="br-pagebody content-container">
          <div className="br-section-wrapper">
            <div className="card">
              <div className="card-header tx-medium tx-uppercase bg-white">
                Company Plan Administrators
              </div>
              <div className="card-body">
                {company?.name ? (
                  <p>Your {company.name} company plan administrators are:</p>
                ) : (
                  <p>Your company plan administrators are:</p>
                )}
                <ul className="admin-list">
                  {planAdmins.length > 0 ? (
                    planAdmins.map((data, i) => (
                      <li key={i}>
                        {data.lastName}, {data.firstName} - {data.email}
                      </li>
                    ))
                  ) : (
                    <p>No plan administrators found.</p>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <>{this.renderContent()}</>;
  }
}
